import axios from "../utils/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getUsers = createAsyncThunk("users", async (payload, thunkAPI) => {
  try {
    const queryParams = new URLSearchParams();

    // Add all available parameters to the query string
    if (payload?.page) queryParams.append("page", payload.page);
    if (payload?.limit) queryParams.append("limit", payload.limit);
    if (payload?.search) queryParams.append("search", payload.search);
    if (payload?.role) queryParams.append("role", payload.role);
    if (payload?.status) queryParams.append("subscriptionStatus", payload.status);
    if (payload?.merchant) queryParams.append("merchantId", payload.merchant);
    if (payload?.fundraiser) queryParams.append("fundraiserId", payload.fundraiser);
    if (payload?.duration) queryParams.append("duration", payload.duration);
    if (payload?.startDate) queryParams.append("startDate", payload.startDate);
    if (payload?.endDate) queryParams.append("endDate", payload.endDate);

    // Build the final URL with all query parameters
    const queryString = queryParams.toString();
    const url = `admin/users?${queryString}`;
    const response = await axios.get(url);
    return response?.data;
  } catch (error) {
    return thunkAPI?.rejectWithValue(error);
  }
});

export const getTransactions = createAsyncThunk(
  "admin/transactions",
  async (filter = "") => {
    try {
      const response = await axios.get(`admin/transactions?filter=${filter}`);
      return response?.data;
    } catch (error) {
      return error;
    }
  }
);

export const getUserById = createAsyncThunk(
  "admin/users",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.get(`admin/users/${payload?.id}`);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

// Admin Dashboard Stats
export const getAdminFundStats = createAsyncThunk(
  "admin/fundStats",
  async (payload = {}, thunkAPI) => {
    try {
      const params = new URLSearchParams();
      if (payload?.timeframe) params.append("timeframe", String(payload.timeframe).toLowerCase());
      // cache buster to avoid 304 when data just changed
      params.append("_", Date.now().toString());
      const url = `admin/fundStats?${params.toString()}`;
      const response = await axios.get(url);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const getAdminFundBreakdown = createAsyncThunk(
  "admin/fundbreakdown",
  async (payload = {}, thunkAPI) => {
    try {
      const params = new URLSearchParams();
      if (payload?.timeframe) params.append("timeframe", String(payload.timeframe).toLowerCase());
      params.append("_", Date.now().toString());
      const url = `admin/fundbreakdown?${params.toString()}`;
      const response = await axios.get(url);
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const getAdminOfferStats = createAsyncThunk(
  "admin/offerStats",
  async (payload = {}, thunkAPI) => {
    try {
      const params = new URLSearchParams();
      if (payload?.timeframe) params.append("timeframe", String(payload.timeframe).toLowerCase());
      // optional: scope by merchant/fundraiser if backend supports it in future
      if (payload?.merchantId) params.append("merchantId", payload.merchantId);
      const qs = params.toString();
      const url = qs ? `admin/offerStats?${qs}` : "admin/offerStats";

      console.log("getAdminOfferStats - GET", url);
      const response = await axios.get(url);
      console.log("getAdminOfferStats - API response:", response?.data);
      return response?.data;
    } catch (error) {
      console.error("getAdminOfferStats - API error:", error);
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

// Active/Inactive status summaries
export const getMerchantStatusSummary = createAsyncThunk(
  "admin/merchantStatus",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get("admin/merchantStatus");
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);

export const getFundraiserStatusSummary = createAsyncThunk(
  "admin/fundraiserStatus",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get("admin/fundraiserStatus");
      return response?.data;
    } catch (error) {
      return thunkAPI?.rejectWithValue(error);
    }
  }
);